import React from 'react';
import ColorTag from '../ColorTag/ColorTag';
var ColorTagFrontLineWorkers = function (props) {
    return React.createElement(ColorTag, { className: "ColorTagFrontLineWorkers", color: "aqua" }, "Front Line Workers");
};
export default ColorTagFrontLineWorkers;
